// import React from "react";

// function UsagePolicy() {
//   return (
//     <div style={{ padding: "20px" }}>
//       <h1>Usage Policy</h1>
//       <p>This is the privacy policy page. Add your content here.</p>
//     </div>
//   );
// }

// export default UsagePolicy;


import React from "react";
import { Container, Box, Typography } from "@mui/material";

function UsagePolicy() {
  return (
    <div style={{ backgroundColor: "#fffdf8", minHeight: "100vh", width: "100%", fontFamily: "'Lato', sans-serif" }}>
      <Container style={{ padding: "40px 20px", maxWidth: "1000px" }}>
        
        <Box mb={4} textAlign="center">
          <Typography style={{ paddingTop: "80px", fontFamily: "'Lato', sans-serif", fontWeight: "bold", fontSize: "80px" }} variant="h3" gutterBottom>
            Usage Policy
          </Typography>
          <Typography variant="subtitle1" color="textSecondary">
            Effective Date: February 25, 2025
          </Typography>
        </Box>

        <Box mb={3}>
          <Typography style={{ fontFamily: "'Playfair-Display, serif", fontSize: "21px", fontWeight: 500, WebkitFontSmoothing: "antialiased", MozOsxFontSmoothing: "grayscale" }} paragraph>
            Wolfe Technologies Inc. (“Wolfe,” “we,” “our,” or “us”) provides AI-powered mental health support services. This Usage Policy outlines the acceptable and prohibited uses of Wolfe’s platform to ensure a safe and supportive experience for all users. By using Wolfe, you agree to comply with this policy.
          </Typography>
        </Box>

        <Box mb={3}>
          <Typography style={{ fontFamily: "'Lato', sans-serif", fontWeight: 600, fontSize: "25px" }} variant="h5" gutterBottom>
            1. Acceptable Use
          </Typography>
          <ul>
            <li>
              <Typography style={{ fontFamily: "'Playfair-Display, serif", fontSize: "21px", fontWeight: 500, WebkitFontSmoothing: "antialiased", MozOsxFontSmoothing: "grayscale" }}>
                Engaging in self-improvement, emotional support, and well-being discussions.
              </Typography>
            </li>
            <li>
              <Typography style={{ fontFamily: "'Playfair-Display, serif", fontSize: "21px", fontWeight: 500, WebkitFontSmoothing: "antialiased", MozOsxFontSmoothing: "grayscale" }}>
                Utilizing AI-generated responses for guidance within ethical and non-exploitative contexts.
              </Typography>
            </li>
            <li>
              <Typography style={{ fontFamily: "'Playfair-Display, serif", fontSize: "21px", fontWeight: 500, WebkitFontSmoothing: "antialiased", MozOsxFontSmoothing: "grayscale" }}>
                Respecting the rights and privacy of others when interacting with Wolfe.
              </Typography>
            </li>
          </ul>
        </Box>

        <Box mb={3}>
          <Typography style={{ fontFamily: "'Lato', sans-serif", fontWeight: 600, fontSize: "25px" }} variant="h5" gutterBottom>
            2. Prohibited Uses
          </Typography>

          <Typography style={{ fontFamily: "'Playfair-Display, serif", fontSize: "21px", fontWeight: 500, WebkitFontSmoothing: "antialiased", MozOsxFontSmoothing: "grayscale" }} paragraph>
            You must not use Wolfe’s services for:
          </Typography>

          <ul><Typography style={{ fontFamily: "'Lato', sans-serif", fontWeight: 600, fontSize: "22px" }}>
                A. Medical or Crisis Situations</Typography>
              <ul>
                <li><Typography style={{ fontFamily: "'Playfair-Display, serif", fontSize: "21px", fontWeight: 500 }}>Seeking medical diagnoses, treatment, or emergency intervention.</Typography></li>
                <li><Typography style={{ fontFamily: "'Playfair-Display, serif", fontSize: "21px", fontWeight: 500 }}>Using Wolfe as a substitute for professional therapy or crisis hotlines.</Typography></li>
                <li><Typography style={{ fontFamily: "'Playfair-Display, serif", fontSize: "21px", fontWeight: 500 }}>Ignoring immediate professional help in crisis situations.</Typography></li>
              </ul>


            
              <Typography style={{ fontFamily: "'Lato', sans-serif", fontWeight: 600, fontSize: "22px" }}>
                B. Harmful or Illegal Activities
              </Typography>
              <ul>
                <li><Typography style={{ fontFamily: "'Playfair-Display, serif", fontSize: "21px", fontWeight: 500 }}>Promoting, encouraging, or engaging in self-harm, suicide, eating disorders, or excessive dieting/exercise.</Typography></li>
                <li><Typography style={{ fontFamily: "'Playfair-Display, serif", fontSize: "21px", fontWeight: 500 }}>Threatening, harassing, stalking, or intimidating any person or entity.</Typography></li>
              </ul>
          

       
              <Typography style={{ fontFamily: "'Lato', sans-serif", fontWeight: 600, fontSize: "22px" }}>
                C. Misinformation & Manipulation
              </Typography>
              <ul>
                <li><Typography style={{ fontFamily: "'Playfair-Display, serif", fontSize: "21px", fontWeight: 500 }}>Spreading false or misleading health, medical, or psychological information.</Typography></li>
                <li><Typography style={{ fontFamily: "'Playfair-Display, serif", fontSize: "21px", fontWeight: 500 }}>Using Wolfe to generate deceptive or manipulative content for exploitation.</Typography></li>
              </ul>

          </ul>
        </Box>

        <Box mb={3}>
          <Typography style={{ fontFamily: "'Lato', sans-serif", fontWeight: 600, fontSize: "25px" }} variant="h5" gutterBottom>
            3. Enforcement & Consequences
          </Typography>
          <ul>
            <li>
              <Typography style={{ fontFamily: "'Playfair-Display, serif", fontSize: "21px", fontWeight: 500 }}>
                Wolfe reserves the right to monitor and review interactions to ensure compliance with this policy.
              </Typography>
            </li>
            <li>
              <Typography style={{ fontFamily: "'Playfair-Display, serif", fontSize: "21px", fontWeight: 500 }}>
                Wolfe may restrict, suspend, or terminate access for users who violate these guidelines.
              </Typography>
            </li>
            <li>
              <Typography style={{ fontFamily: "'Playfair-Display, serif", fontSize: "21px", fontWeight: 500 }}>
                Wolfe may report illegal activities to relevant authorities when required.
              </Typography>
            </li>
          </ul>
        </Box>

        <Box mb={3}>
          <Typography style={{ fontFamily: "'Lato', sans-serif", fontWeight: 600, fontSize: "25px" }} variant="h5" gutterBottom>
            4. Updates & Contact
          </Typography>
          <Typography style={{ fontFamily: "'Playfair-Display, serif", fontSize: "21px", fontWeight: 500, WebkitFontSmoothing: "antialiased", MozOsxFontSmoothing: "grayscale" }} paragraph>
            Wolfe may update this Usage Policy as needed to maintain ethical and responsible AI use. If you have any questions or concerns, contact us at <strong>support@hellowolfe.com</strong>.
          </Typography>
        </Box>

        <Typography style={{ fontFamily: "'Playfair-Display, serif", fontSize: "21px", fontWeight: 500, WebkitFontSmoothing: "antialiased", MozOsxFontSmoothing: "grayscale" }} paragraph>
          By using Wolfe, you acknowledge and agree to abide by this Usage Policy.
        </Typography>

      </Container>
    </div>
  );
}

export default UsagePolicy;
